export default __webpack_public_path__ + "static/MediaMainBannerMobile-a094886e3fbc8d7dc0dfb200e2d32d52.webp";